const getDefault = () => {
  return {
    deliveryOption: null,
    deliveryDate: null,
    deliveryId: null
  }
}

export default {
  namespaced: true,
  state: Object.assign({}, getDefault()),
  mutations: {
    SAVE_DELIVERY_OPTION(state, data) {
      state.deliveryOption = data
    },
    SAVE_DATE(state, data) {
      state.deliveryDate = data
    },
    SAVE_DELIVERY_ID(state, data) {
      state.deliveryId = data
    },
    // eslint-disable-next-line no-unused-vars
    RESET_STATE_ALL(state) {
      state = Object.assign(state, getDefault())
    }
  }
}
